import { LysepAPI } from '../contexts/ApiContext';

const DockerService = {
    // List containers
    listContainers: async (serverId) => {
        const response = await LysepAPI.get(`/api/servers/${serverId}/docker/containers`);
        return response.data;
    },

    // Get container status
    getContainerStatus: async (serverId, containerName) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/status`, { containerName });
        return response.data;
    },

    // Start container
    startContainer: async (serverId, containerName) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/start`, { containerName });
        return response.data;
    },

    // Stop container
    stopContainer: async (serverId, containerName) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/stop`, { containerName });
        return response.data;
    },

    // Restart container
    restartContainer: async (serverId, containerName) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/restart`, { containerName });
        return response.data;
    },

    // Remove container
    removeContainer: async (serverId, containerName, force = false) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/remove`, { containerName, force });
        return response.data;
    },

    // Get logs
    getLogs: async (serverId, containerName, lines = 100) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/logs`, { containerName, lines });
        return response.data;
    },

    // Get stats
    getStats: async (serverId, containerName) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/containers/stats`, { containerName });
        return response.data;
    },

    // Custom command
    executeCommand: async (serverId, command) => {
        const response = await LysepAPI.post(`/api/servers/${serverId}/docker/command`, { command });
        return response.data;
    }
};

export default DockerService;
